<template>
  <div>
    <v-dialog v-model="show_error_supplier_or_customer_not_found" persistent max-width="500">
      <FixSuppCostNotFound v-if="this.currentDoc && this.currentDoc.state == 'error_supplier_or_customer_not_found'"></FixSuppCostNotFound>
    </v-dialog>
    <MessagePopup message="There are some wrong labeled fields. Please, correct the red ones and press CONTINUE."
     :show_message="show_error_validating_data" @close-message="show_error_validating_data=false">
    </MessagePopup>
    <MessagePopup message="The credit and the debit are not matching. Please, correct account move lines and press CONTINUE."
     :show_message="show_error_validating_moves" @close-message="show_error_validating_moves=false">
    </MessagePopup>
    <MessagePopup message="Some taxes are not correct. Please, correct the red ones and press CONTINUE."
     :show_message="show_error_checking_taxes" @close-message="show_error_checking_taxes=false">
    </MessagePopup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FixSuppCostNotFound from './FixSuppCostNotFound.vue';
import MessagePopup from './/MessagePopup.vue';


export default {
  name: 'ErrorPipelinePopup',
  components:{
    FixSuppCostNotFound,
    MessagePopup
  },
  props: {
    
  },
  computed:{
    show_error_supplier_or_customer_not_found() {
      if(this.currentDoc){
        this.show_error_validating_data = this.currentDoc.state == 'error_validating_data';
        this.show_error_validating_moves = this.currentDoc.state == 'error_validating_moves';
        this.show_error_checking_taxes = this.currentDoc.state == 'error_checking_taxes';
      }
      return this.currentDoc && this.currentDoc.state == 'error_supplier_or_customer_not_found';
    },
    ...mapState(['currentDoc'])
  },
  methods:{
    
  },
  data() {
    return {
      show_error_validating_data: false,
      show_error_validating_moves: false,
      show_error_checking_taxes: false,
    }
  }
}
</script>

